import { useMemo, useContext } from 'react';
import WizardStateContext from 'components/Wizards/shared/context/wizardstate';
import { AREA_RESPONSES } from 'components/Wizards/RTDV/types';

const useShouldExpandModal = (objectId, currentDashboard) => {
  const { state } = useContext(WizardStateContext.Context);

  return useMemo(() => {
    const { reportType, customStylesEnabled, field } = state;
    const isTable = reportType?.value === AREA_RESPONSES.TABLE;
    const isPivotTable = reportType?.value === AREA_RESPONSES.PIVOT_TABLE;
    const showColumnBuilder = isTable || isPivotTable;
    const hasDashboardStyles =
      currentDashboard?.styleSettings &&
      Object.keys(currentDashboard.styleSettings).length > 0;
    const showCustomizedStyles =
      !customStylesEnabled || !objectId || !field
        ? false
        : hasDashboardStyles || customStylesEnabled;

    return showColumnBuilder || showCustomizedStyles;
  }, [state, objectId, currentDashboard?.styleSettings]);
};

export default useShouldExpandModal;
